
import React from 'react';

import ModificationView from './Modification.view';
import OperationList from './OperationList.state';

const Modification = ({
    modification,
    operations,
    quantity,
    usek,
    usekAttributes
}) => {

    const renderOperationList = () => {
        return (
            <OperationList
                operations={operations}
                quantity={quantity}
                usek={usek}
                usekAttributes={usekAttributes}
            />
        );
    }

    return (
        <ModificationView
            quantity={quantity}
            modification={modification}
            operationList={renderOperationList()}
        />
    );
}

export default Modification;
